export function Art({
  kind = "heart",
  className = "",
}: {
  kind?: string;
  className?: string;
}) {
  return (
    <svg
      className={`art ${className}`}
      viewBox="0 0 180 140"
      fill="none"
      aria-hidden="true"
    >
      <g
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {kind === "coffee" ? (
          <>
            <path d="M51 61h63v30c0 39-63 39-63 0V61Z" fill="white" fillOpacity="0.72" />
            <path d="M114 65h11c23 0 22 32-11 30M41 120h88M69 43c-14-12 12-13 0-26M87 43c-14-12 12-13 0-26M104 43c-14-12 12-13 0-26" />
            <path
              d="M73 83c7-12 16-4 12 4-5 8-8 8-8 8s-11-8-8-13"
              fill="#b77358"
              stroke="none"
            />
          </>
        ) : kind === "dishes" ? (
          <>
            <ellipse cx="91" cy="80" rx="40" ry="41" fill="white" fillOpacity="0.72" />
            <ellipse cx="91" cy="80" rx="28" ry="29" />
            <path d="M34 47v30c0 12 13 12 13 0V47M40 47v72M143 47v72M142 47c-14 0-19 37 0 37M65 25l3-8 3 8 8 3-8 3-3 8-3-8-8-3 8-3Z" />
            <path
              d="m110 17 3 6 7 1-5 5 1 7-6-3-7 3 2-7-5-5 7-1Z"
              fill="#cab979"
            />
          </>
        ) : kind === "moon" ? (
          <>
            <path
              d="M114 26a47 47 0 1 0 28 79 52 52 0 0 1-28-79Z"
              fill="white"
              fillOpacity="0.78"
            />
            <path d="m134 25 3 9 10 1-8 6 3 10-8-5-8 5 3-10-8-6 10-1ZM44 29l2 6 6 2-6 2-2 6-2-6-6-2 6-2Z" />
            <path d="M81 98c8 5 18 2 21-4" />
          </>
        ) : kind === "sun" ? (
          <>
            <circle cx="90" cy="72" r="30" fill="#eecb79" />
            <path d="M90 24V11M90 120v10M42 72H29M138 72h13M55 37l-9-9M124 107l9 9M124 37l9-9M55 107l-9 9M80 77c5 8 15 8 20 0" />
            <circle cx="78" cy="67" r="1" />
            <circle cx="101" cy="67" r="1" />
          </>
        ) : kind === "movie" ? (
          <>
            <rect x="40" y="46" width="102" height="68" rx="8" fill="white" fillOpacity="0.72" />
            <path d="m40 46 96-23 6 23M61 41l9-17M86 35l10-17M113 28l7-16M79 66l26 14-26 16Z" />
          </>
        ) : (
          <>
            <path
              d="M90 113S31 79 41 49c8-24 39-21 49 1 10-22 41-25 49-1 10 30-49 64-49 64Z"
              fill="white"
              fillOpacity="0.78"
            />
            <path d="M90 97S56 76 57 59M27 30l-8-7M151 100l10 7M144 21l6-11M24 96l-10 3" />
            <path d="m130 108 3 8 8 2-8 3-3 8-2-8-8-3 8-2Z" fill="#c8956e" />
          </>
        )}
      </g>
    </svg>
  );
}
